import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeGb from '@angular/common/locales/en-GB';
import { UtilityModule } from './utility/utility.module';
import { AuthService } from './auth/auth.service';

registerLocaleData(localeGb);

export function initApp(authService: AuthService) {
  return () => {
    let token: any = '';

    const url = new URL(window.location.href);
    token = url.searchParams.get('token');

    if (!token) {
      token = document.cookie
        .split('; ')
        .find(row => row.startsWith('ff_sub_token='))
        ?.substring('ff_sub_token='.length) ?? '';
    }

    if (token && token.length) {
      authService.setSessionToken(token);
      document.cookie = `ff_sub_token=${token}; path=/; SameSite=None; Secure`;
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
    } else {
      authService.setSessionToken("expired");
    }

    return Promise.resolve();
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    UtilityModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-GB' },
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
